// extracted by css-extract-rspack-plugin
export default {"root":"Iz7uT0","menu-item":"ml89uE","menuItem":"ml89uE","selected":"DJpWPc"};